import React, { useRef, useState } from 'react';
import Dashboard from './Dashboard';
import Copyright from '@/components/Copyright';
import PageToolbar from '@/components/PageToolbar';
import { useTranslation } from 'react-i18next';


import {
  startOfWeek,
  endOfWeek,
  addDays,
  subDays,
  startOfMonth,
  addMonths,
  endOfMonth
} from 'date-fns';
import { DateRangePicker, Panel, Stack } from 'rsuite';

import type { RangeType } from 'rsuite/DateRangePicker';

interface Range extends RangeType {
  appearance?: 'default' | 'primary' | 'link' | 'subtle' | 'ghost';
}

// const predefinedRanges: Range[] = [
  
//   {
//     label: t('Today'),
//     value: [new Date(), new Date()],
//     placement: 'left'
//   },
//   {
//     label: t('Yesterday'),
//     value: [addDays(new Date(), -1), addDays(new Date(), -1)],
//     placement: 'left'
//   },
//   {
//     label: t('This week'),
//     value: [startOfWeek(new Date()), endOfWeek(new Date())],
//     placement: 'left'
//   },
//   {
//     label: t('Last 7 days'),
//     value: [subDays(new Date(), 6), new Date()],
//     placement: 'left'
//   },
//   {
//     label: t('Last 30 days'),
//     value: [subDays(new Date(), 29), new Date()],
//     placement: 'left'
//   },
//   {
//     label: t('This month'),
//     value: [startOfMonth(new Date()), new Date()],
//     placement: 'left'
//   },
//   {
//     label: t('Last month'),
//     value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
//     placement: 'left'
//   },
//   {
//     label: t('This year'),
//     value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
//     placement: 'left'
//   },
//   {
//     label: t('Last year'),
//     value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
//     placement: 'left'
//   },
//   {
//     label: t('All time'),
//     value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date()],
//     placement: 'left'
//   },
//   {
//     label: t('Last week'),
//     closeOverlay: false,
//     value: value => {
//       const [start = new Date()] = value || [];
//       return [
//         addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
//         addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
//       ];
//     },
//     appearance: 'default'
//   },
//   {
//     label: t('Next week'),
//     closeOverlay: false,
//     value: value => {
//       const [start = new Date()] = value || [];
//       return [
//         addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
//         addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
//       ];
//     },
//     appearance: 'default'
//   }
// ];

const Index = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const [dates, setDates] = useState([
    startOfWeek(new Date(), { weekStartsOn: 1 }),
    endOfWeek(new Date(), { weekStartsOn: 1 })
  ]);
  const predefinedRanges: Range[] = [
  
    {
      label: t('Today'),
      value: [new Date(), new Date()],
      placement: 'left'
    },
    {
      label: t('Yesterday'),
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: 'left'
    },
    {
      label: t('This week'),
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: 'left'
    },
    {
      label: t('Last 7 days'),
      value: [subDays(new Date(), 6), new Date()],
      placement: 'left'
    },
    {
      label: t('Last 30 days'),
      value: [subDays(new Date(), 29), new Date()],
      placement: 'left'
    },
    {
      label: t('This month'),
      value: [startOfMonth(new Date()), new Date()],
      placement: 'left'
    },
    {
      label: t('Last month'),
      value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'left'
    },
    {
      label: t('This year'),
      value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
      placement: 'left'
    },
    {
      label: t('Last year'),
      value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
      placement: 'left'
    },
    {
      label: t('All time'),
      value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date()],
      placement: 'left'
    },
    {
      label: t('Last week'),
      closeOverlay: false,
      value: value => {
        const [start = new Date()] = value || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
        ];
      },
      appearance: 'default'
    },
    {
      label: t('Next week'),
      closeOverlay: false,
      value: value => {
        const [start = new Date()] = value || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
        ];
      },
      appearance: 'default'
    }
  ];
  return (
    <Panel
      header={
        <Stack justifyContent="space-between">
          <h3 className="title">{t('Business travel dashboard')}</h3>
          <DateRangePicker
            appearance="subtle"
            defaultValue={[new Date(), new Date()]}
            showOneCalendar
            ranges={predefinedRanges}
            container={() => containerRef.current as HTMLDivElement}
            onChange={value => {
              setDates(value);
            }}
            value={dates}
            format="dd-MM-yyyy"
          />
        </Stack>
      }
    >
      <Dashboard dates={dates} />
      {/* <MapClusters /> */}
      <Copyright />
    </Panel>
  );
};

export default Index;
